// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboHM{width:300px;border:1px solid #e2e2e7;box-shadow:0px 2px 4px rgba(0,0,0,.04);border-radius:16px;margin:10px}`, "",{"version":3,"sources":["webpack://./src/widgets/ProductChip/ProductChip.module.scss"],"names":[],"mappings":"AAAA,OACI,WAAA,CACA,wBAAA,CACA,sCAAA,CACA,kBAAA,CACA,WAAA","sourcesContent":[".tile {\n    width: 300px;\n    border: 1px solid #e2e2e7;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);\n    border-radius: 16px;\n    margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `AboHM`
};
export default ___CSS_LOADER_EXPORT___;
